import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";

export const DropdownMenuShortcut = ({ className, ...props }: ComponentProps<"span">) => (
  <span
    data-slot="dropdown-menu-shortcut"
    className={cn("ml-auto text-xs tracking-widest text-muted-foreground", className)}
    {...props}
  />
);
